export default "__VITE_ASSET__Cp3Oa21O__"